import { apiInstance } from "@core/api/axios/apiInstance";
import { parseSchema } from "@core/model/parseSchema";
import { mainICafeResponseSchema, type MainICafeResponseType } from "@features/account/model/response/mainICafe.response";

/**
 * 대표 피씨방 설정
 * @param iCafeId (PC방 ID)
 */
export const fetchMainICafe = async (iCafeId: string) => {
  const res = await apiInstance.post("/icafe/me/main-icafe", { iCafeId: iCafeId });

  return parseSchema<MainICafeResponseType>({
    schema: mainICafeResponseSchema,
    rawData: res?.data,
  });
};
